import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../../components/ui/button';
import { Chrome, Lock } from 'lucide-react';
import { SITE_LOGO_PATH } from '../../config/brand';

const AdminLogin = () => {
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { isAuthenticated, loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleGoogleLogin = async () => {
    setError('');
    setSubmitting(true);
    const result = await loginWithGoogle();
    setSubmitting(false);
    if (!result.ok) {
      setError(result.error || 'Google login failed');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-gray-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-xl p-8">
          <div className="text-center mb-8">
            <img
              src={SITE_LOGO_PATH}
              alt="Swaarnim Book of Records logo"
              className="mx-auto mb-6 h-16 w-56 object-contain"
            />
            <div className="inline-flex items-center justify-center w-16 h-16 bg-red-700 rounded-full mb-4">
              <Lock className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-3xl font-bold text-gray-800">Admin Login</h1>
          </div>

          <div className="space-y-6">
            <p className="text-center text-sm text-gray-600">
              Sign in with your admin account.
            </p>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                {error}
              </div>
            )}

            <Button
              type="button"
              onClick={handleGoogleLogin}
              disabled={submitting}
              className="w-full bg-red-700 hover:bg-red-800 text-white py-3"
            >
              <Chrome className="mr-2 h-5 w-5" />
              {submitting ? 'Opening Google...' : 'Continue with Google'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
